/**
 * נתוני דמה לתצוגה מקדימה של ווידג'טים
 */

// נתוני דמה לווידג'ט זמנים
export const dummyZmanimData = {
    zmanim: {
        alotHaShachar: '05:15',
        sunrise: '06:30',
        sofZmanShmaMGA: '08:45',
        sofZmanShma: '09:15',
        sofZmanTfillaMGA: '09:45',
        sofZmanTfilla: '10:15',
        chatzot: '12:30',
        minchaGedola: '13:00',
        sunset: '18:45',
        tzeit85deg: '19:20',
        chatzotNight: '00:30'
    },
    hebrewDate: 'ה\' בשבט תשפ"ו',
    loading: false,
    error: null,
    customTimes: [
        { label: 'שחרית', time: '07:00', type: 'fixed' },
        { label: 'מנחה', time: '18:00', type: 'fixed' }
    ],
    shabbatCustomTimes: []
};

// נתוני דמה לווידג'ט מזג אוויר
export const dummyWeatherData = {
    weather: {
        temp: 22,
        condition: 'sunny',
        description: 'שמש',
        humidity: 65,
        wind: 12
    },
    loading: false,
    error: null
};

// נתוני דמה לווידג'ט שבת
export const dummyShabbatData = {
    shabbat: {
        meta: {
            candleLighting: '17:30',
            havdalah: '18:45'
        },
        friday: {
            sunset: '17:45',
            tzeit85deg: '18:20'
        },
        shabbat: {
            sunset: '17:46',
            tzeit85deg: '18:21'
        }
    },
    loading: false,
    error: null,
    customTimes: [
        { label: 'מנחה', time: '18:00', type: 'fixed', day: 'friday' },
        { label: 'ערבית', time: '19:30', type: 'fixed', day: 'shabbat' }
    ]
};

// נתוני דמה לווידג'ט טקסט
export const dummyTextData = {
    text: '<p style="text-align: center;"><strong>ברוכים הבאים</strong></p><p>זהו טקסט לדוגמה</p>'
};

// נתוני דמה ללוח מודעות
export const dummyNoticeBoardData = {
    data: {
        notices: [
            { id: 1, content: '<p>מודעה ראשונה לדוגמה</p>' },
            { id: 2, content: '<p>מודעה שנייה לדוגמה</p>' }
        ]
    }
};

// נתוני דמה לחירום והצלה
export const dummyEmergencyData = {
    data: {
        volunteers: {
            medic: [
                { id: 1, name: 'יוסי כהן', phone: '050-1234567' }
            ],
            paramedic: [
                { id: 2, name: 'דוד לוי', phone: '052-9876543' }
            ],
            maar: []
        }
    }
};

// נתוני דמה לאנשי קשר
export const dummyContactsData = {
    data: {
        contacts: [
            { id: 1, name: 'הרב משה כהן', phone: '050-1111111', role: 'רב הקהילה' },
            { id: 2, name: 'אברהם לוי', phone: '052-2222222', role: 'גבאי' }
        ]
    }
};

// נתוני דמה לשמחות
export const dummySimchaData = {
    data: {
        simchas: [
            { id: 1, name: 'משפחת כהן', type: 'birth_boy', celebrant: 'יעקב' },
            { id: 2, name: 'משפחת לוי', type: 'wedding_boy', celebrant: 'דוד' }
        ]
    }
};

// נתוני דמה לנציב הקהילה
export const dummyNitzavData = {
    data: {
        name: 'משפחת כהן',
        dedication: 'לעילוי נשמת ר\' יעקב בן אברהם ז"ל',
        type: 'נציב היום',
        iconId: 'star'
    }
};

// נתוני דמה להוצאות
export const dummyExpensesData = {
    data: {
        categories: [
            { name: 'תחזוקה', amount: 5000, color: '#1e3a5f' },
            { name: 'חשמל', amount: 3000, color: '#d4af37' },
            { name: 'מים', amount: 2000, color: '#8b7355' }
        ]
    },
    freeText: 'סה"כ הוצאות חודשיות'
};

// נתוני דמה לתמונת מצב כספית
export const dummyFinancialGaugeData = {
    data: {
        incomeData: [
            { id: 'donations', label: 'תרומות', value: 3000, color: '#1e3a5f' },
            { id: 'events', label: 'הוראות קבע', value: 6000, color: '#2d5a8f' }
        ],
        expensesData: [
            { id: 'maintenance', label: 'תחזוקה', value: 5000, color: '#e6c45e' },
            { id: 'utilities', label: 'חשמל ומים', value: 6000, color: '#f0d98d' }
        ]
    }
};

// נתוני דמה לתמונה
export const dummyImageData = {
    imageUrl: '/inorai-logo.png'
};

// נתוני דמה לווידג'ט מועד
export const dummyMoadData = {
    moadData: {
        days: [
            {
                date: '2026-04-02',
                label: 'ערב פסח',
                entryTime: '19:10',
                exitTime: '20:25',
                zmanim: { sunset: '19:10', tzeit85deg: '19:45', chatzot: '12:30', sofZmanShma: '09:15' }
            },
            {
                date: '2026-04-03',
                label: 'פסח א׳',
                entryTime: '19:11',
                exitTime: '20:26',
                zmanim: { sunset: '19:11', tzeit85deg: '19:46', chatzot: '12:31', sofZmanShma: '09:15' }
            }
        ]
    },
    customTimes: [
        { label: 'ערבית', time: '20:30', type: 'fixed', dayIndex: 0 },
        { label: 'שחרית', time: '08:00', type: 'fixed', dayIndex: 1 }
    ],
    loading: false,
    error: null
};

// נתוני דמה לווידג'ט תפילות יום חול
export const dummyTefilotData = {
    tefilotData: {
        zmanim: {
            alotHaShachar: '05:15',
            netzHachama: '06:20',
            sunset: '17:50',
            tzeit85deg: '18:25',
            chatzot: '12:30',
            sofZmanShma: '09:10',
            sofZmanShmaMGA: '08:32'
        }
    },
    customTimes: [
        {
            prayer: 'shacharit', label: 'שחרית',
            type: 'recurring',
            startType: 'fixed', startTime: '06:30',
            endType: 'fixed', endTime: '08:30',
            interval: 30,
            dayOverrides: [{ days: [1, 4], type: 'fixed', time: '07:00' }]
        },
        { prayer: 'mincha', label: 'מנחה', type: 'fixed', time: '17:20' },
        {
            prayer: 'maariv', label: 'ערבית',
            type: 'recurring',
            startType: 'relative', startBaseTime: 'daySunset', startOffset: 10, startRoundTo: 5,
            endType: 'relative', endBaseTime: 'daySunset', endOffset: 70, endRoundTo: 5,
            interval: 20
        }
    ],
    loading: false,
    error: null
};

// נתוני דמה לווידג'ט פרנס קהילה
const TODAY = new Date().toISOString().split('T')[0];
const NEXT_SHABBAT = (() => {
    const d = new Date();
    const daysToSat = (6 - d.getDay() + 7) % 7 || 7;
    d.setDate(d.getDate() + daysToSat);
    return d.toISOString().split('T')[0];
})();

export const dummyOmerData = {
    omerDay: 33,
    isOmerSeason: true,
    nusach: 'ashkenaz',
    showBracha: true,
    showFullNusach: true,
    showLeshemYichud: false,
    showPasuk: 'none',
    showAfterCount: false,
};

// נתוני דמה לווידג'ט ענייני היום
export const dummyInyaneiData = {
    items: [
        { category: 'tachanun', icon: 'HandMetal', label: 'תחנון', value: 'אין תחנון', detail: 'ראש חודש', priority: 'normal' },
        { category: 'hallel', icon: 'Music', label: 'הלל', value: 'חצי הלל', detail: 'ראש חודש', priority: 'normal' },
        { category: 'prayerAdditions', icon: 'Plus', label: 'יעלה ויבוא', value: 'ר״ח', detail: null, priority: 'normal' },
        { category: 'seasonalPrayers', icon: 'CloudRain', label: 'גשם/טל', value: 'משיב הרוח ומוריד הגשם', detail: null, priority: 'normal' },
        { category: 'seasonalPrayers', icon: 'CloudRain', label: 'ברכת השנים', value: 'ותן טל ומטר', detail: null, priority: 'normal' },
        { category: 'liturgy', icon: 'BookOpen', label: 'מוסף', value: 'מוסף ראש חודש', detail: null, priority: 'normal' },
        { category: 'seasonalCustoms', icon: 'Scroll', label: 'ספירת העומר', value: 'יום ל״ג', detail: null, priority: 'normal' },
    ],
    hebrewDate: 'א׳ אייר תשפ״ו',
    loading: false,
    error: null,
};

// נתוני דמה לווידג'ט לימודים יומיים
export const dummyLimudimData = {
    items: [
        { key: 'dafYomi',    labelHe: 'דף יומי',    valueHe: 'מנחות דף פ״ד',               category: 'gemara',  url: 'https://www.sefaria.org/Menachot.84a' },
        { key: 'mishnaYomi', labelHe: 'משנה יומית',  valueHe: 'תמיד ד:א-ב',                 category: 'mishna',  url: 'https://www.sefaria.org/Mishnah_Tamid.4.1' },
        { key: 'rambam1',    labelHe: 'רמב"ם יומי',  valueHe: 'הלכות קריאת שמע פרק ד',      category: 'halacha', url: 'https://www.sefaria.org/Mishneh_Torah' },
        { key: 'nachYomi',   labelHe: 'נ"ך יומי',    valueHe: 'שְׁמוּאֵל א׳ ח׳',            category: 'tanakh',  url: 'https://www.sefaria.org/I_Samuel.8' },
        { key: 'chofetzChaim', labelHe: 'חפץ חיים',  valueHe: 'הלכות לשון הרע 10.9-10.10',   category: 'mussar',  url: null },
        { key: 'psalms',     labelHe: 'תהילים יומי', valueHe: 'תְּהִלִּים פ״ח-פ״ט',          category: 'tanakh',  url: 'https://www.sefaria.org/Psalms.88' },
    ],
    hebrewDate: 'א׳ אייר תשפ״ו',
};

export const dummySeatingMapData = {
    mapData: {
        width: 40, height: 30, seatSize: 0.9,
        landmarks: [
            { id: 'aron', type: 'aronHaKodesh', x: 15, y: 0, width: 10, height: 2, visible: true },
            { id: 'bima', type: 'bima', x: 14, y: 13, width: 12, height: 3, visible: true },
            { id: 'amud', type: 'amudTefilla', x: 17, y: 3, width: 6, height: 1.5, visible: true },
            { id: 'entrance', type: 'entrance', x: 15, y: 29, width: 10, height: 1, visible: true },
        ],
        rows: [
            { id: 'r1', x: 2, y: 5, seats: [{ id: 's1', occupant: 'כהן משה' }, { id: 's2', occupant: 'לוי דוד' }, { id: 's3', occupant: '' }, { id: 's4', occupant: 'ישראלי יוסף' }, { id: 's5', occupant: '' }, { id: 's6', occupant: 'אברהם' }] },
            { id: 'r2', x: 2, y: 6.4, seats: [{ id: 's7', occupant: '' }, { id: 's8', occupant: 'שמעון בן דוד' }, { id: 's9', occupant: 'רפאל' }, { id: 's10', occupant: '' }, { id: 's11', occupant: 'חיים' }, { id: 's12', occupant: '' }] },
            { id: 'r3', x: 2, y: 7.8, seats: [{ id: 's13', occupant: 'נתן' }, { id: 's14', occupant: '' }, { id: 's15', occupant: '' }, { id: 's16', occupant: 'מרדכי' }, { id: 's17', occupant: 'אליהו' }, { id: 's18', occupant: '' }] },
            { id: 'r4', x: 31.4, y: 5, seats: [{ id: 's19', occupant: '' }, { id: 's20', occupant: 'יצחק' }, { id: 's21', occupant: 'שלמה כהן' }, { id: 's22', occupant: '' }, { id: 's23', occupant: '' }, { id: 's24', occupant: 'עמנואל' }] },
            { id: 'r5', x: 31.4, y: 6.4, seats: [{ id: 's25', occupant: 'בנימין' }, { id: 's26', occupant: '' }, { id: 's27', occupant: '' }, { id: 's28', occupant: 'גד' }, { id: 's29', occupant: '' }, { id: 's30', occupant: 'זבולון' }] },
            { id: 'r6', x: 31.4, y: 7.8, seats: [{ id: 's31', occupant: '' }, { id: 's32', occupant: 'אשר' }, { id: 's33', occupant: 'דן' }, { id: 's34', occupant: '' }, { id: 's35', occupant: 'נפתלי' }, { id: 's36', occupant: '' }] },
        ],
        colors: { occupied: '#1e3a5f', empty: '#86efac', landmark: '#8a6d08' },
    },
};

export const dummyParnasData = {
    parnasType: 'maor',
    parnasTypeIcon: 'star',
    parnasTypeCustomLabel: '',
    sponsors: [
        {
            id: 'demo-1',
            name: 'משפחת כהן',
            slots: [{ id: 's1', type: 'daily', date: TODAY, hDate: 'היום', note: 'לעילוי נשמת אבינו מורינו', icon: null }]
        },
        {
            id: 'demo-2',
            name: 'משפחת לוי',
            slots: [{ id: 's2', type: 'weekly', parshaName: 'ויקרא', parshaShabbatDate: NEXT_SHABBAT, note: '', icon: 'book' }]
        },
        {
            id: 'demo-3',
            name: "ר' ישראל ישראלי",
            slots: [{ id: 's3', type: 'monthly', hebrewMonth: 7, hebrewYear: 5786, hebrewMonthName: 'תשרי', note: 'לרפואת שלמה', icon: null }]
        },
    ]
};



// נתוני דמה לווידג'ט מניין הבא
export const dummyNextMinyaData = {
    prayers: [
        { label: 'שחרית',  time: '07:30', prayer: 'shacharit', color: '#0369a1', source: 'tefilot' },
        { label: 'מנחה',   time: '14:30', prayer: 'mincha',    color: '#0369a1', source: 'tefilot' },
        { label: 'מעריב',  time: '19:15', prayer: 'maariv',    color: '#0369a1', source: 'tefilot' },
    ],
    // 06:00 — ensures שחרית 07:30 always appears as "next"
    previewNow: 360,
};
